"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _InputBase = _interopRequireDefault(require("../InputBase"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "value", "setValue", "label"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = "";
  var fileName = "InputEmail_InputEmail";
  var element = document.querySelector("style[data-sass-component='InputEmail_InputEmail']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var InputEmail = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$setValue = _ref.setValue,
    _setValue = _ref$setValue === void 0 ? function () {} : _ref$setValue,
    label = _ref.label,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  // it's looking for the last character to not allowing to enter 2 special characters together
  var sameCharacterTwice = function sameCharacterTwice(stringToCompare) {
    if (stringToCompare.charAt(stringToCompare.length - 1).match(/[@.!#$%&'*+/=?^`{|-]/)) {
      return stringToCompare.charAt(stringToCompare.length - 1) === stringToCompare.charAt(stringToCompare.length - 2);
    }
    return false;
  };

  // validates that no bad chars are used. **maybe there should be more characteres allowed?**
  // the second replace it doesn't allow to type a wrong first character for the email. (When onblur, regex used won't validate those characters. That's why it doesn't allow to enter them as the first character. ).

  var formatEmail = function formatEmail(email) {
    var charAllowedEmail = email.replace(/[^0-9A-Za-z@._!#$%&'*+/=?^`{|-]~/g, '').replace(/^[-_@.!#$%&'*+/=?^`{|]~/, '');
    var createFormat = sameCharacterTwice(charAllowedEmail) ? charAllowedEmail.substring(0, charAllowedEmail.length - 1) : charAllowedEmail;
    return createFormat;
  };
  var isEmailValid = function isEmailValid(email) {
    if (email.match(/^\w+([.!#$%&'*+/=?^`{|-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/g) === null) {
      return false;
    }
    return true;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread({
    type: "text",
    label: label,
    className: "InputEmail ".concat(className),
    formatValue: formatEmail,
    isValid: isEmailValid,
    value: value,
    ref: ref,
    setValue: function setValue(val) {
      _setValue(formatEmail(val));
    }
  }, rest));
});
InputEmail.displayName = 'InputEmail';
var _default = InputEmail;
exports["default"] = _default;